import { put2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { CashDroSettings } from "@/shared/v2/queries/interfacesV2";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const useCashDroSettingsPut = () => {
  const branch = useBranchId();
  const queryClient = useQueryClient();

  const mutation = useMutation<CashDroSettings, unknown, CashDroSettings>({
    mutationFn: async (settings) =>
      put2(`internal/secure/pos/v1/cashdro/settings/${branch}`, settings),
    onSuccess: (settings) => {
      queryClient.setQueryData(["cashDroSettings", branch], settings);
    },
  });

  return mutation;
};

export default useCashDroSettingsPut;
